export { default as i18n } from "./i18n";
export { default } from "./AvailabilityCalendar";

import { ProviedProps } from "./AvailabilityCalendar";
export type AvailabilityCalendarProps = ProviedProps;
